<template>
  <div class="menu-guide" v-if="isShowGuide">
    <i class="el-icon-caret-left"></i>
    <div class="title">
      {{ $t('menuCollected') }}
    </div>
    <div class="content">{{ $t('menuCollectedCont') }}</div>
    <span class="known-btn" @click="handleHide">{{ $t('knew') }}</span>
  </div>
</template>

<script>
import { userInfo } from '@/global.js'
export default {
  name: 'MenuGuide',
  data() {
    return {
      isShowGuide: true,
      userInfo: userInfo
    }
  },
  methods: {
    handleHide() {
      try {
        // TODO: IE8+
        const strVisitedMenuGuide = localStorage.getItem('visitedLeftMenuGuide')
        const visitedMenuGuide = strVisitedMenuGuide ? JSON.parse(strVisitedMenuGuide) : []
        // 已看过
        visitedMenuGuide.push(this.userInfo.userCode)
        localStorage.setItem('visitedLeftMenuGuide', JSON.stringify(visitedMenuGuide))
        this.isShowGuide = false
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .menu-guide {
    position: absolute;
    top: 16px;
    left: calc(100% + 10px);
    width: 320px;
    min-height: 116px;
    color: #fff;
    border-radius: 8px;
    background: #3C6EF0;
    padding: 16px;
    box-sizing: border-box;
    .el-icon-caret-left {
      position: absolute;
      left: -9px;
      top: 20px;
      color: #3C6EF0;
    }
    .title {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 600;
      color: rgba(255,255,255,1);
      margin-bottom: 10px;
    }
    .content {
      line-height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: normal;
      color: rgba(255,255,255,0.8);
    }
    .known-btn {
      height: 24px;
      line-height: 24px;
      background: rgba(255,255,255,1);
      border-radius: 8px;
      color: #3C6EF0;
      text-align: center;
      float: right;
      font-size: 12px;
      cursor: pointer;
      padding: 0 16px;
    }
  }

</style>
